import {  html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { FormBase } from './formBase';

@customElement('landing-x')
export class LandingForm extends FormBase {
  static styles = css`
    .animate__animated {
      animation-duration: 0.7s;
    }
    
    .right-out-left-in-animation {
      animation-name: slideOutRight, slideInLeft;
    }
    
    .left-out-right-in-animation {
      animation-name: slideOutLeft, slideInRight;
    }
    
    @keyframes slideOutRight {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
    
    @keyframes slideInLeft {
      from { transform: translateX(-100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    
    @keyframes slideOutLeft {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(-100%); opacity: 0; }
    }
    
    @keyframes slideInRight {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
  `;

  @property({ type: Number }) pos = 0;
  @property({ type: Number }) maxPosReached = 0;
  @property({ type: String }) logo = '';
  @property({ type: String }) headerBgColor = '';
  @property({ type: String }) details = '';
  @property({ type: Boolean }) paymentsPage = false;
  @property({ type: String }) loading = 'false';
  @property({ type: String }) height = '';
  @property({ type: String }) maxHeight = '';
  @property({ type: Boolean }) isSectionPage = false;
  @property({ type: Array }) sections: any[] = [];

  firstUpdated() {
    this.setCardContentHeight();
  }

  updated(changedProperties: Map<string, any>) {
    changedProperties.forEach((oldValue, propName) => {
      if (propName === "pos" && !isNaN(oldValue)) {
        this.positionTransition(oldValue);
      }
    });
  }

  positionTransition(oldPosition: number) {
    const formXCard = this.shadowRoot?.querySelector(".form-x-card") as HTMLElement;
    if (!formXCard) return;

    const triggerTransition = (direction: string, oppositeDirection: string) => {
      formXCard.classList.add(`${direction}-out-${oppositeDirection}-in-animation`, 'animate__animated');

      setTimeout(() => {
        formXCard.classList.remove(`${direction}-out-${oppositeDirection}-in-animation`, 'animate__animated');
      }, 700);
    };
    
    if (this.pos > oldPosition) {
      triggerTransition("right", "left");
    }

    if (this.pos < oldPosition) {
      triggerTransition("left", "right");
    }
  }

  renderStepper() {
    // Don't show stepper on first step or if we haven't reached step 2 yet
    if (this.pos === 0 || this.maxPosReached < 1) {
      return html``;
    }

    // Determine how many steps to show (maxPosReached + 1)
    const stepCount = this.maxPosReached + 1;

    return html`
      <div class="flex items-center justify-center space-x-4 py-4">
        ${Array.from({ length: stepCount }).map((_, index) => {
          const isActive = index === this.pos;
          const isCompleted = index < this.pos;
          const isDisabled = index > this.maxPosReached;
          
          const stepClasses = `
            w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium border-2 transition-all duration-300 cursor-pointer
            ${isActive ? 'bg-blue-600 text-white border-blue-600 scale-110' : ''}
            ${isCompleted ? 'bg-green-500 text-white border-green-500' : ''}
            ${isDisabled ? 'bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed' : 'hover:bg-blue-100 hover:border-blue-400'}
            ${!isActive && !isCompleted && !isDisabled ? 'bg-white text-gray-600 border-gray-300' : ''}
          `;
          
          return html`
            <div class="flex flex-col items-center">
              <div 
                class="${stepClasses}"
                @click="${() => !isDisabled && this._goToStep(index)}"
              >
                ${index + 1}
              </div>
              <span class="text-xs mt-1 text-gray-600">${this.getStepLabel(index)}</span>
            </div>
          `;
        })}
      </div>
    `;
  }

  getStepLabel(index: number) {
    try {
      const details = JSON.parse(this.details);
      if (details.stepLabels && details.stepLabels[index]) {
        return details.stepLabels[index];
      }
    } catch (e) {
      // console.log('Could not parse details for step labels');
    }
    return `Step ${index + 1}`;
  }

  render() {
    const cardStyle = this.paymentsPage ? 'shadow-none' : 'shadow-lg';
    // const headerStyle = this.headerBgColor ? `background-color: ${this.headerBgColor}` : '';

    return html`
      <div class="card form-x-card ${cardStyle} bg-white rounded-lg border border-gray-200 overflow-hidden">
        ${
          this.checkLoading() ? html`
            <div class="overlay absolute inset-0 bg-white bg-opacity-70 z-10"></div>
          ` : html``
        }
        
        
        
        ${
          this.checkLoading() ? html`
            <div class="pro-container px-6 py-2">
              <div class="w-full bg-gray-200 rounded-full h-2">
                <div class="bg-blue-600 h-2 rounded-full animate-pulse"></div>
              </div>
            </div>
          ` : html``
        }
        
        <div class="card-content px-6 py-4 ${this.checkForDialog()}">
          <slot name="body"></slot>
        </div>
      </div>
    `;
  }

  setCardContentHeight() {
    let section = document.querySelector("section-page");

    if (this.maxHeight || this.height) {
      if (section != null && section.id == "dialog" && window.TEMPLATE == 'service') {
        const cardContent = this.shadowRoot?.querySelector(".card-content") as HTMLElement;
        if (cardContent) {
          if (this.height) cardContent.style.height = this.height;
          if (this.maxHeight) cardContent.style.maxHeight = this.maxHeight;
        }
      }
    }
  }


  _notifyPosChange(newPos: number) {
    this.dispatchEvent(new CustomEvent('pos-change', {
      bubbles: true,
      composed: true,
      detail: { pos: newPos },
    }));
  }

  // _back(evt: Event) {
  //   this.pos -= 1;
  //   this._notifyPosChange(this.pos);
  // }

  // _forward(evt: Event) {
  //   this.pos += 1;
  //   this._notifyPosChange(this.pos);
  // }

  // _hideB(p: number, s: any[]) {
  //   return p === 0;
  // }

 _goToStep(index: number) {
  if (index < 0 || index >= this.sections.length) return;
  
  // Check if we're going backwards
  if (index < this.pos) {
    // Dispatch event that will trigger FormRender to clear future steps
    this.dispatchEvent(new CustomEvent('step-navigate-back', {
      bubbles: true,
      composed: true,
      detail: { newPos: index }
    }));
  }
  
  this.pos = index;
  this._notifyPosChange(this.pos);
}

  _hideF(p: number, s: any[]) {
    return p >= s.length - 1;
  }

  checkForDialog() {
    return this.isSectionPage ? "overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100" : "";
  }

  checkLoading() {    
    return this.loading === "true";
  }
}